export default __webpack_public_path__ + "static/media/hidraulic14.465c2ceb.jpg";